import styled from 'styled-components';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from '@algoan/dashboard/store/store';
import { checkingAndSavingsAccountsSelector } from '@algoan/dashboard/store/selectors';
import { Filter, FilterBottomMargin, FilterRow, FilterVariant } from '../atomic-components';
import { accountMessages } from '../../messages';

export const AccountsFilter: React.FC<{ selectedAccount?: string; onClick: (accountId?: string) => void }> = ({
  selectedAccount,
  onClick,
}) => {
  const accounts = useSelector(checkingAndSavingsAccountsSelector);
  const intl = useIntl();

  return (
    <>
      {Array.isArray(accounts) && accounts.length > 0 && (
        <S.Container>
          <S.Title>
            <FormattedMessage
              id="widgets.bank_history.filter.title"
              defaultMessage="Filter by account"
              description="Filter title"
            />
          </S.Title>
          <FilterRow>
            {accounts.length > 1 && (
              <Filter
                withBottomMargin={FilterBottomMargin.LARGE}
                selected={typeof selectedAccount === 'undefined'}
                onClick={() => onClick(undefined)}
                variant={FilterVariant.LEGACY}
              >
                <FormattedMessage
                  id="widgets.bank_history.filter.every_accounts"
                  defaultMessage="Every account"
                  description="Select every account button"
                />
              </Filter>
            )}
            {accounts.map((account, index) => (
              <Filter
                key={index}
                withBottomMargin={FilterBottomMargin.LARGE}
                selected={selectedAccount === account.id || accounts.length === 1}
                onClick={() => onClick(account.id)}
                variant={FilterVariant.LEGACY}
              >
                {account.name ?? intl.formatMessage(accountMessages[account.type], { index: account.index })}
              </Filter>
            ))}
          </FilterRow>
        </S.Container>
      )}
    </>
  );
};

const S = {
  Container: styled.div`
    display: flex;
    padding: 13px 13px 0 13px;
  `,
  Title: styled.div`
    color: ${(props) => props.theme.algoanBlue};
    font-size: 11px;
    height: 14px;
    line-height: 14px;
    margin-right: 16px;
    width: 93px;
  `,
};
